<template>
  <div>
    <Form
      label-position="right"
      :label-width="90"
      :model="formData"
      ref="form"
      :rules="ruleValidate"
    >
      <FormItem label="模版组名称:" prop="name">
        <Input placeholder="请输入模版组名称" v-model="formData.name"></Input>
      </FormItem>
      <FormItem label="排序:" prop="sort">
        <Input number placeholder="请输入排序" v-model="formData.sort"></Input>
      </FormItem>
      <FormItem label="模版组描述:" prop="note">
        <Input
          v-model="formData.note"
          placeholder="请输入模版组描述,最多200字"
          type="textarea"
          maxlength="200"
          show-word-limit
        ></Input>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { tempGroupRuleValidate } from './modalConfig.js';
import { getSortMax } from '@/api/tempGroupManage';
export default {
  name: 'TempGroupModal',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        name: '',
        sort: '',
        note: ''
      },
      ruleValidate: tempGroupRuleValidate
    };
  },
  computed: {
    ...mapState('tempGroupManage', ['detail'])
  },
  methods: {
    ...mapActions('tempGroupManage', ['getDetail', 'submitTempGroup']),
    submit() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitTempGroup({
              formData: this.formData,
              isEdit: this.isEdit
            }).then(res => {
              if (res) {
                resolve(true);
              }
            });
          }
        });
      });
    },
    setFormData(val) {
      const keys = Object.keys(val);
      const formData = {};
      keys.forEach(key => {
        formData[key] = val[key];
      });
      this.formData = formData;
    },
    getSortMax() {
      getSortMax().then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          this.formData.sort = data;
        }
      });
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getDetail({ id: this.id });
    } else {
      this.getSortMax();
    }
  },
  watch: {
    detail(val) {
      if (val.id) {
        console.log('datava=====', val);
        this.setFormData(val);
      }
    }
  }
};
</script>
<style lan="less"></style>
